/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HomeAttention,
  HomeLater,
  LocationsHomeAttentionRetrieveParams,
  LocationsHomeLaterRetrieveParams
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getLocationsHomeAttentionRetrieveUrl = (locationId: number,
    params?: LocationsHomeAttentionRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/locations/${locationId}/home/attention/?${stringifiedParams}` : `/api/locations/${locationId}/home/attention/`
}

/**
 * Business Home, top of the page: blockers, shifts needing attention, unpaid Pros and hiring. Only rows that need action are returned; fetch the full object by id when a row is opened.
 */
export const locationsHomeAttentionRetrieve = async (locationId: number,
    params?: LocationsHomeAttentionRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<HomeAttention> => {

  return customFetch<HomeAttention>(getLocationsHomeAttentionRetrieveUrl(locationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLocationsHomeAttentionRetrieveQueryKey = (locationId: number,
    params?: LocationsHomeAttentionRetrieveParams,) => {
    return [
    `/api/locations/${locationId}/home/attention/`, ...(params ? [params] : [])
    ] as const;
    }


export const getLocationsHomeAttentionRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof locationsHomeAttentionRetrieve>>, TError = void>(locationId: number,
    params?: LocationsHomeAttentionRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsHomeAttentionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocationsHomeAttentionRetrieveQueryKey(locationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationsHomeAttentionRetrieve>>> = ({ signal }) => locationsHomeAttentionRetrieve(locationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: locationId !== null && locationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locationsHomeAttentionRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LocationsHomeAttentionRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof locationsHomeAttentionRetrieve>>>
export type LocationsHomeAttentionRetrieveQueryError = void


export function useLocationsHomeAttentionRetrieve<TData = Awaited<ReturnType<typeof locationsHomeAttentionRetrieve>>, TError = void>(
 locationId: number,
    params: undefined |  LocationsHomeAttentionRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsHomeAttentionRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsHomeAttentionRetrieve>>,
          TError,
          Awaited<ReturnType<typeof locationsHomeAttentionRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsHomeAttentionRetrieve<TData = Awaited<ReturnType<typeof locationsHomeAttentionRetrieve>>, TError = void>(
 locationId: number,
    params?: LocationsHomeAttentionRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsHomeAttentionRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsHomeAttentionRetrieve>>,
          TError,
          Awaited<ReturnType<typeof locationsHomeAttentionRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsHomeAttentionRetrieve<TData = Awaited<ReturnType<typeof locationsHomeAttentionRetrieve>>, TError = void>(
 locationId: number,
    params?: LocationsHomeAttentionRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsHomeAttentionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLocationsHomeAttentionRetrieve<TData = Awaited<ReturnType<typeof locationsHomeAttentionRetrieve>>, TError = void>(
 locationId: number,
    params?: LocationsHomeAttentionRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsHomeAttentionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationsHomeAttentionRetrieveQueryOptions(locationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getLocationsHomeLaterRetrieveUrl = (locationId: number,
    params?: LocationsHomeLaterRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value instanceof Date ? value.toISOString() : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/locations/${locationId}/home/later/?${stringifiedParams}` : `/api/locations/${locationId}/home/later/`
}

/**
 * Business Home, "for later": Pros to rate, ready to hire, team invites, recurring schedules, shifts worth making recurring and whether the location is new.
 */
export const locationsHomeLaterRetrieve = async (locationId: number,
    params?: LocationsHomeLaterRetrieveParams, options?: Parameters<typeof customFetch>[1]): Promise<HomeLater> => {

  return customFetch<HomeLater>(getLocationsHomeLaterRetrieveUrl(locationId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLocationsHomeLaterRetrieveQueryKey = (locationId: number,
    params?: LocationsHomeLaterRetrieveParams,) => {
    return [
    `/api/locations/${locationId}/home/later/`, ...(params ? [params] : [])
    ] as const;
    }


export const getLocationsHomeLaterRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof locationsHomeLaterRetrieve>>, TError = void>(locationId: number,
    params?: LocationsHomeLaterRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsHomeLaterRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLocationsHomeLaterRetrieveQueryKey(locationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locationsHomeLaterRetrieve>>> = ({ signal }) => locationsHomeLaterRetrieve(locationId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: locationId !== null && locationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locationsHomeLaterRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LocationsHomeLaterRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof locationsHomeLaterRetrieve>>>
export type LocationsHomeLaterRetrieveQueryError = void


export function useLocationsHomeLaterRetrieve<TData = Awaited<ReturnType<typeof locationsHomeLaterRetrieve>>, TError = void>(
 locationId: number,
    params: undefined |  LocationsHomeLaterRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsHomeLaterRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsHomeLaterRetrieve>>,
          TError,
          Awaited<ReturnType<typeof locationsHomeLaterRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsHomeLaterRetrieve<TData = Awaited<ReturnType<typeof locationsHomeLaterRetrieve>>, TError = void>(
 locationId: number,
    params?: LocationsHomeLaterRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsHomeLaterRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof locationsHomeLaterRetrieve>>,
          TError,
          Awaited<ReturnType<typeof locationsHomeLaterRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLocationsHomeLaterRetrieve<TData = Awaited<ReturnType<typeof locationsHomeLaterRetrieve>>, TError = void>(
 locationId: number,
    params?: LocationsHomeLaterRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsHomeLaterRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLocationsHomeLaterRetrieve<TData = Awaited<ReturnType<typeof locationsHomeLaterRetrieve>>, TError = void>(
 locationId: number,
    params?: LocationsHomeLaterRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locationsHomeLaterRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationsHomeLaterRetrieveQueryOptions(locationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






